<script setup lang="ts">
/**
 * Lightweight explainer dialog used on signup details / authorise steps.
 */
import DashboardModal from '@/components/dashboard/ui/DashboardModal.vue'

withDefaults(
  defineProps<{
    isOpen: boolean
    titleId: string
    title: string
    /** Optional lead paragraph above the bullet list. */
    intro?: string
    paragraphs?: string[]
    bullets?: string[]
    /** Closing note after bullets / paragraphs. */
    footerNote?: string
  }>(),
  {
    intro: '',
    paragraphs: () => [],
    bullets: () => [],
    footerNote: '',
  }
)

const emit = defineEmits<{
  close: []
}>()
</script>

<template>
  <DashboardModal
    :is-open="isOpen"
    modal-class="sa-modal--auth-explain"
    :aria-labelledby="titleId"
    @close="emit('close')"
  >
    <h2 :id="titleId" class="sa-modal--auth-explain__title">
      {{ title }}
    </h2>

    <div class="sa-modal--auth-explain__body">
      <p v-if="intro" class="sa-modal--auth-explain__text">
        {{ intro }}
      </p>

      <p
        v-for="(paragraph, index) in paragraphs"
        :key="`p-${index}`"
        class="sa-modal--auth-explain__text"
      >
        {{ paragraph }}
      </p>

      <ul v-if="bullets.length" class="sa-modal--auth-explain__list">
        <li v-for="(item, index) in bullets" :key="`b-${index}`">
          {{ item }}
        </li>
      </ul>

      <p v-if="footerNote" class="sa-modal--auth-explain__text">
        {{ footerNote }}
      </p>
    </div>

    <template #footer>
      <div class="sa-modal-actions sa-modal--auth-explain__actions">
        <button type="button" class="sa-btn-primary" @click="emit('close')">
          {{ $t('Buttons.Close') }}
        </button>
      </div>
    </template>
  </DashboardModal>
</template>
